<template>
  <div class="main-content">
    <div class="sidebar">
      <LeftPanel 
        ref="leftPanel"
        @depot-mode-changed="handleDepotModeChanged"
        @location-creation-mode-changed="handleLocationCreationModeChanged"
        @clear-map="handleClearMap"
        @clear-selection="handleClearSelection"
        @solution-found="handleSolutionFound"
        @locations-visibility-changed="handleLocationsVisibilityChanged"
        @load-saved-routes="handleLoadSavedRoutes"
        @location-source-changed="handleLocationSourceChanged"
      />
    </div>
    <div class="map-area">
      <MapComponent 
        ref="mapComponent"
        :depot-mode="depotMode"
        :location-creation-mode="locationCreationMode"
        :show-locations="showDbLocations"
        :location-source="locationSource"
        :selected-collection-id="selectedCollectionId"
        @depot-set="handleDepotSet"
        @location-added="handleLocationAdded"
        @locations-selected="handleLocationsSelected"
        @boundary-selected="handleBoundarySelected"
        @locations-filtered="handleLocationsFiltered"
      />
    </div>
  </div>
</template>

<script>
import LeftPanel from '../components/LeftPanel.vue'
import MapComponent from '../components/MapComponent.vue'

export default {
  name: 'Home',
  components: {
    LeftPanel,
    MapComponent
  },
  data() {
    return {
      depotMode: false,
      locationCreationMode: false,
      showDbLocations: false,
      locationSource: 'database',
      selectedCollectionId: '',
      boundaryFilteredLocations: null, // Locations filtered by boundary selection
      selectedBoundary: null // Currently selected boundary
    };
  },
  methods: {
    handleDepotModeChanged(mode) {
      this.depotMode = mode;
    },
    
    handleLocationCreationModeChanged(mode) {
      this.locationCreationMode = mode;
    },
    
    handleClearMap() {
      this.$refs.mapComponent.clearMarkers();
      this.$refs.mapComponent.clearRoutes();
    },
    
    handleDepotSet(coordinates) {
      this.$refs.leftPanel.setDepot(coordinates);
    },
    
    handleLocationAdded(coordinates) {
      this.$refs.leftPanel.addLocation(coordinates);
    },
    
    handleSolutionFound(data) {
      // Check if solution is null (clearing case)
      if (!data.solution) {
        // Clear routes and markers when solution is null
        this.$refs.mapComponent.clearRoutes();
        return;
      }
      
      if (data.solverType === 'LAP') {
        // Handle LAP visualization
        this.$refs.mapComponent.displayLAPAllocation(data.solution);
      } else {
        // Handle VRP/TSP route visualization
        this.$refs.mapComponent.displayRoutes(
          data.solution, 
          data.allLocations, 
          data.routeColors
        );
      }
    },
    
    handleLocationsVisibilityChanged(visible) {
      this.showDbLocations = visible;
    },
    
    handleLoadSavedRoutes() {
      this.$refs.mapComponent.loadSavedRoutes();
    },
    
    handleLocationsSelected(locations) {
      // Pass selected locations to the left panel for VRP configuration
      this.$refs.leftPanel.handleSelectedLocations(locations);
    },
    
    handleClearSelection() {
      // Clear the selection on the map
      this.$refs.mapComponent.clearSelection();
    },
    
    handleLocationSourceChanged(data) {
      this.locationSource = data.source;
      this.selectedCollectionId = data.collectionId;
    },
    
    handleBoundarySelected(boundary) {
      console.log('Boundary selected in Home:', boundary);
      this.selectedBoundary = boundary;
      // Pass boundary info to LeftPanel if needed
      if (this.$refs.leftPanel) {
        this.$refs.leftPanel.handleBoundarySelected(boundary);
      }
    },
    
    handleLocationsFiltered(filteredLocations) {
      console.log('Locations filtered in Home:', filteredLocations?.length || 'all');
      this.boundaryFilteredLocations = filteredLocations;
      // Pass filtered locations to LeftPanel for routing
      if (this.$refs.leftPanel) {
        this.$refs.leftPanel.handleLocationsBoundaryFiltered(filteredLocations);
      }
    }
  }
}
</script>

<style scoped>
.main-content {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.sidebar {
  min-width: 380px;
  width: 380px;
  height: 100%;
  overflow-y: hidden;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}

.map-area {
  flex: 1;
  overflow: hidden;
}
</style>
